import axios from '../../axios/index.js'

export default {
    
    getDonutsInfo(data){
        return axios.post('/accounting/donutsInfo',data)
    },
    ExpenseData(id){
        return axios.get('/expense/data/'+id)
    },
    
    biReportDonutInfo(data) {
        return axios.get('/bi_report/donutInfo', {params:data})
    },
    biReportBarInfo(data) {
        return axios.get('/bi_report/barInfo', {params:data})
    }
}
  